import type { Definition } from '@exodus/dependency-types';

const createWeb3HandlersApi = ({ web3 }) => {
  return {
    web3: {
      handleProviderRequest: web3.handleProviderRequest,
      verifyOrigin: web3.verifyOrigin,
    },
  };
};

const web3ApiDefinition = {
  id: 'web3Api',
  type: 'api',
  factory: createWeb3HandlersApi,
  dependencies: ['web3'],
} as const satisfies Definition;

export default web3ApiDefinition;
